module.exports = __webpack_public_path__ + "static/media/at-the-top-dubai.7182f11b.png";